import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ServiceLayerService {

  private readonly CONTROLLER = 'b1s/v1';

  constructor(private http: HttpClient) {
  }

  Login(){
    let path: string = 'https://cltst03.clavisco.com:50000/' + this.CONTROLLER + '/Login';

    return this.http.post<any>(path, {
      CompanyDB: 'TST_CL_DEMOCR',
      UserName: 'CLAVISCO\\cl.desarrollo.sql1',
      Password: 'JzjF#yK7Gs'
    });
  }
}
